if ( typeof HoculusColorSwatch !== 'function' ) {

    class HoculusColorSwatch extends HTMLElement {
        constructor() {
            super();

            this.config = JSON.parse(this.dataset.config);
            this.addEventListener('click', this.handleSwatchClick.bind(this));

            if (this.config.skuPrefix) {
                this.init();
            } else {
                this.removeSwatch();
            }
        }

        removeSwatch() {
            const container = this.closest('.hoculus-swatch-container');

            if (container) {
                container.remove();
            } else {
                this.remove();
            }
        }

        handleSwatchClick(event) {
            const link = event.target.closest('.color-swatch__link');
            const productCard = this.closest('.grid-product');

            if (!link || !productCard || !this.contains(link)) return;

            event.preventDefault();

            const images = productCard.querySelectorAll('.grid__item-image-wrapper image-element img');
            const primaryImageUrl = link.dataset.imageUrl;

            if (!primaryImageUrl || !images.length) return;

            this.updateImage(images[0], primaryImageUrl, link.dataset.imageAlt);

            if (images[1] && link.dataset.secondaryImageUrl) {
                this.updateImage(images[1], link.dataset.secondaryImageUrl, link.dataset.imageAlt);
            }

            productCard.querySelectorAll('.grid-product__link').forEach((productLink) => {
                productLink.href = link.href;
            });

            this.querySelectorAll('.hoculus-swatch.active').forEach((swatch) => {
                swatch.classList.remove('active');
            });
            link.querySelector('.hoculus-swatch')?.classList.add('active');
        }

        updateImage(image, url, alt) {
            image.srcset = '';
            image.src = url;

            if (alt) {
                image.alt = alt;
            }
        }

        async init() {
            const swatchMarkup = await this.getSwatchMarkup();
            
            if (swatchMarkup) {
                const dom = new DOMParser().parseFromString(swatchMarkup, 'text/html');
                const section = dom.querySelector('.shopify-section');
                let html = section?.innerHTML.trim();

                if (html) {

                    html = `
                        ${this.appendTitleMarkup()}
                        ${html}
                    `;

                    this.querySelector('.hoculus-color-swatch').innerHTML = html;
                    if (this.config.useOverrideSwatchImage === true) {
                        this.querySelectorAll('.color-swatch__link[data-custom-swatch-image-url]').forEach((link) => {
                            const imageUrl = link.dataset.customSwatchImageUrl;
                            let swatch = link.querySelector('.hoculus-swatch');

                            if (!swatch) {
                                swatch = document.createElement('div');
                                swatch.className = 'hoculus-swatch';
                                link.append(swatch);
                            }

                            swatch.style.backgroundImage = `url("${imageUrl}")`;
                            swatch.style.backgroundSize = 'cover';
                            swatch.style.backgroundPosition = 'center';
                        });
                    }

                    if (this.config.onlyAvailable === true) {
                        this.querySelectorAll('.color-swatch__link[data-available="false"]').forEach((link) => {
                            link.remove();
                        });
                    }

                    const activeSwatchLink = [...this.querySelectorAll('.color-swatch__link')].find((link) => {
                        return link.dataset.productSku === this.config.productSku;
                    });
                    const activeSwatch = activeSwatchLink?.querySelector('.hoculus-swatch');

                    if (activeSwatch) {
                        activeSwatch.classList.add('active');
                        this.updateTitleColor(activeSwatch.closest('.color-swatch__link').dataset.colorName);
                    }

                    this.renderSwatchToggle();
                } else {
                    this.removeSwatch();
                }
            } else {
                this.removeSwatch();
            }
        }

        renderSwatchToggle() {
            if (this.config.swatchShape !== 'square') return;

            const wrapper = this.querySelector('.color-swatch__wrapper');
            const links = wrapper?.querySelectorAll('.color-swatch__link');
            const swatchesToShow = Number(this.config.swatchesToShow) || 7;

            if (!wrapper || !links || links.length <= swatchesToShow) return;

            links.forEach((link, index) => {
                if (index >= swatchesToShow) link.classList.add('hidden');
            });

            const toggleId = `swatch-toggle-${this.config.productId}`;
            const toggle = document.createElement('input');
            toggle.type = 'checkbox';
            toggle.id = toggleId;

            const label = document.createElement('label');
            label.className = 'color-swatch__toggle hoculus-swatch';
            label.htmlFor = toggleId;
            label.innerHTML = `<span class="count-text">+ ${links.length - swatchesToShow}</span><span class="hide-text">${this.config.hideLabel}</span>`;

            wrapper.append(toggle, label);
        }

        async getSwatchMarkup() {
            try {

                const response = await fetch(`${window.Shopify.routes.root}collections/all?filter.p.m.hoculus.sku_prefix=${this.config.skuPrefix}&section_id=hoculus-products-sku-prefix`);

                const markup = await response.text();

                return markup;

            } catch (err) {
                console.log(err);
                return '';
            }
        }

        appendTitleMarkup() {
            return this.config.title ? `<div class="hoculus-swatch__title">
                <p>${this.config.title}</p>
            </div>` : '';
        }
        
        updateTitleColor(colorName) {
            const titleEl = this.querySelector('.hoculus-swatch__title p');
            if (titleEl) {
                titleEl.textContent = titleEl.textContent.replace('[COLORE_SELEZIONATO]', colorName);
            }
        }
    }

    if ( !customElements.get('hoculus-color-swatch') ) {
        customElements.define('hoculus-color-swatch', HoculusColorSwatch);
    }

}